import { render, staticRenderFns } from "./ElectionCountView.vue?vue&type=template&id=baa9fe58&scoped=true&"
var script = {}
import style0 from "./ElectionCountView.vue?vue&type=style&index=0&id=baa9fe58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9fe58",
  null
  
)

export default component.exports